import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  errors: [],
};

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    showError: (_, { payload }) => ({
      show: true,
      errors: [...payload.errors],
    }),
    closeError: () => ({ show: false, errors: [] }),
  },
});

export const handleError = createAsyncThunk(
  "errors/handleError",
  async (err, { dispatch }) => {
    try {
      console.error(err);

      if (err.json) {
        const error = await err.json();

        console.error(error);

        let errorDetails = [];

        // Intentar parsear el campo errors si viene como string JSON
        if (error.error?.errors) {
          try {
            errorDetails =
              typeof error.error.errors === "string"
                ? JSON.parse(error.error.errors)
                : error.error.errors;
          } catch (e) {
            errorDetails = [];
          }
        }

        const errorMessages = [
          error.error?.message ?? "No especificado",
          ...(errorDetails?.map?.((validationError) => {
            // Construir mensaje detallado con información del campo y valor
            let detailedMsg = validationError.msg;

            // if (validationError.param) {
            //   detailedMsg += ` (Campo: ${validationError.param})`;
            // }

            // if (validationError.value !== undefined && validationError.value !== null) {
            //   detailedMsg += ` [Valor recibido: ${validationError.value}]`;
            // }

            return detailedMsg;
          }) ?? []),
        ];

        return dispatch(showError({ errors: errorMessages }));
      }

      throw err;
    } catch (err) {
      dispatch(showError(["Error desconocido"]));
    }
  }
);

export const { showError, closeError } = errorsSlice.actions;
export default errorsSlice.reducer;
